<template>
	<div class="challenge-item">
		<div class="block-not-collected">
			<div class="d-flex">
				<div class="challenge-image">
					<ResponsiveImage :height-proportion="100" :image="getChallengeImageUrl(item.image_id)" />
				</div>

				<div class="challenge-main-block">
					<div class="title">
						{{ getTranslation(item.title) }}
					</div>

					<div class="challenge-intro-text">
						{{ getTranslation(item.text) }}
					</div>

					<div v-if="!isMobile" class="button-row ">
						<div v-if="item.points" class="btn-collect-points" @click.stop="collectAchievement()">
							<div class="btn-collect">
								{{ t.dashboardCollectPoints }}
							</div><div class="btn-points">
								+{{ item.points }}
							</div>
						</div>

						<div v-else @click.stop="collectAchievement()">
							<div class="btn-collect-nopoints">
								{{ t.dashboardCollectPointsZero }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="isMobile" class="button-row ">
				<div v-if="item.points" class="btn-collect-points" @click.stop="collectAchievement()">
					<div class="btn-collect">
						{{ t.dashboardCollectPoints }}
					</div><div class="btn-points">
						+{{ item.points }}
					</div>
				</div>

				<div v-else @click.stop="collectAchievement()">
					<div class="btn-collect-nopoints">
						{{ t.dashboardCollectPointsZero }}
					</div>
				</div>
			</div>
		</div>		
	</div>
</template>

<script setup>
import { computed, inject } from "vue";
import { getTranslation, getChallengeImageUrl } from "../../includes/helpers"
import { $emit } from "@/js/includes/event-bus";
import { useStore } from '@/js/stores/index';
import ResponsiveImage from "../blocks/responsive-image.vue";

const axios = inject('axios')
const store = useStore()

// Props
const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
})

// Computed
const t = computed(() => store.translations)
const isMobile = computed(() => store.isMobile)

// Methods
async function collectAchievement(){
	await axios.post('/api/user-side/collectUserAchievement', {
		achievement_id: props.item.id
	})

	$emit('achievement-collected', props.item);
}
</script>
